//Todo: write own magnolia form after this the js should be unnecessary

export class Magnoliaformstyler {
    init() {
        this.checkRows();
    }

    checkRows() {
        const mgnlForms = [...document.querySelectorAll('.form')];

        if (mgnlForms.length) {
            mgnlForms.forEach(form => {

                // js old form, can  be removed after formchange in magnolia---------- ToDo
                if (!form.classList.contains('form-js')) {
                    this.reformatOldForms(form)
                }
                if (form.classList.contains('form-js')) {
                    const rows = [...form.querySelectorAll('.form-row')];
                    if (rows.length) {
                        rows.forEach(row => {
                            const wrapper = row.querySelector('.form-input__wrapper');

                            if (row.classList.contains('form-input__checkbox-row')) {
                                const label = row.querySelector('label')
                                label.innerHTML = label.innerText
                            }

                            const fileInput = row.querySelector('input[type="file"]');
                            if (fileInput) {
                                if (wrapper) {
                                    fileInput.addEventListener('change', () => this.onFileInputChange(wrapper, fileInput));
                                    wrapper.classList.add('form-input__wrapper-file')
                                }
                            }

                            const fileDelete = row.querySelector('.form-input__file-delete');
                            if (fileDelete) {
                                if (wrapper) {
                                    fileDelete.addEventListener('click', () => this.deleteFile(wrapper));
                                }
                            }
                        })
                    }
                }
            })
        }
    }

    // js old form, can  be removed after formchange in magnolia---------- ToDo
    /**
     * @deprecated
     * @param form
     */
    reformatOldForms(form){
        form.classList.add('col-md-8', 'col-12');
        // wrap form in row
        const wrapperRow = document.createElement('div');
        wrapperRow.classList.add('row');
        form.parentNode.insertBefore(wrapperRow, form);
        wrapperRow.appendChild(form);

        const rows = form.querySelectorAll('.form-row');
        if (rows.length) {
            rows.forEach(row => {
                const label = row.querySelector('label');
                const area = row.querySelector('textarea');
                const input = row.querySelector('input[type="file"]') || row.querySelector('input[type="text"]') || row.querySelector('input[type="number"]');
                const checkboxInput = row.querySelector('input[type="checkbox"]');

                const fileSelect = row.querySelector('select');

                const wrapper = document.createElement('div');
                wrapper.classList.add('form-input__wrapper')

                if (label && area) {
                    wrapper.appendChild(label);
                    wrapper.appendChild(area);
                } else if (input && label) {
                    wrapper.appendChild(label);
                    wrapper.appendChild(input);
                } else if (fileSelect && label) {
                    wrapper.appendChild(label);
                    wrapper.appendChild(fileSelect);
                    row.classList.add('form-input__select-row')

                    const icon = document.createElement('div');
                    icon.classList.add('form-input__select-icon');
                    wrapper.appendChild(icon);
                    icon.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="6" height="9" viewBox="0 0 6 9"> <polygon fill-rule="evenodd" points=".656 7.671 3.804 4.516 .656 1.36 1.625 .391 5.75 4.516 1.625 8.641"/> </svg>';

                } else if (label && checkboxInput) {
                    wrapper.appendChild(checkboxInput);
                    label.innerHTML = label.innerText
                    wrapper.appendChild(label);
                    row.classList.add('form-input__checkbox-row')
                } else return
                row.appendChild(wrapper)

                // remove error fields
                const haveError = wrapper.querySelector('em');
                if (haveError) {
                    wrapper.classList.add('error')
                }

                const fileInput = row.querySelector('input[type="file"]');
                if (fileInput) {
                    fileInput.addEventListener('change', () => this.onFileInputChange(wrapper, fileInput));
                    wrapper.classList.add('form-input__wrapper-file');
                }
            })
        }
    }

    // if files where uploaded
    onFileInputChange(wrapper, fileInput) {
        const inputFilesWrapper = wrapper.querySelector('ul') || document.createElement('ul');
        inputFilesWrapper.classList.add('form-input__files')
        const newRow = document.createElement('div');
        newRow.classList.add('form-row');
        wrapper.querySelectorAll('.form-input__error-text.file-upload')[0].remove();

        try {
            inputFilesWrapper.innerHTML = '';
            newRow.innerHTML = '';
            for (let x = 0; x < fileInput.files.length; x++) {
                //add to list
                const li = document.createElement('li');
                li.classList.add('form-input__file')
                const uploadedFile = fileInput.files[x];

                document.querySelectorAll('.form-input__instruction').forEach(function(el) {
                    el.style.display = 'none';
                });
                document.querySelectorAll('.form-input__wrapper-file').forEach(function(el) {
                    el.classList.add('form-input__uploaded');
                });
                const fileUploadField = document.querySelector("div[data-type='template']").cloneNode(true);
                const time = new Date().getTime()
                fileUploadField.setAttribute("data-type", "");
                fileUploadField.style.display = "block";
                fileUploadField.id = "fileUpload_" + time;
                fileUploadField.querySelector("i").style.display = "block";
                fileUploadField.querySelector("label").setAttribute("for", fileInput.name + "_" + time);
                fileUploadField.querySelector("input").name = fileInput.name + "_" + time;
                fileUploadField.querySelector("input").id = fileInput.name + "_" + time;
                fileUploadField.querySelector("input").removeAttribute("disabled");

                const spanFileName = document.createElement('span');
                spanFileName.classList.add('form-input__file-name')
                spanFileName.innerHTML = uploadedFile.name;

                const spanFileSize = document.createElement('span');
                spanFileSize.classList.add('form-input__file-size')
                spanFileSize.innerHTML = (uploadedFile.size / (1024 * 1024)).toFixed(2) + 'MB';

                const spanFileDelete = document.createElement('span');
                spanFileDelete.classList.add('form-input__file-delete')


                inputFilesWrapper.appendChild(li);
                li.appendChild(spanFileName);
                li.appendChild(spanFileSize);
                li.appendChild(spanFileDelete);
                newRow.appendChild(fileUploadField);
            }
        } catch (e) {
            return
        }
        wrapper.appendChild(inputFilesWrapper)
        wrapper.parentNode.insertBefore(newRow, wrapper.nextSibling)
        this.checkRows();
    }
    deleteFile(wrapper) {
        let checkRequired = wrapper.querySelectorAll('input[type=file]')[0].hasAttribute('required');
        wrapper.remove();
        if (checkRequired) {
            const firstFileInput = document.querySelectorAll('.form-input__wrapper-file input')[0];
            firstFileInput.setAttribute("required","");
        }
    }
}
